import { faFileExcel } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Stack } from "@mui/material";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

export const EmptyResult = ({
  noItemsText,
  onClearFilters,
}: {
  noItemsText: string;
  onClearFilters?: () => void;
}) => {
  return (
    <Stack
      spacing={4}
      alignItems="center"
      justifyContent="center"
      sx={{
        width: "100%",
        height: "100%",
        px: 6,
        color: "secondary.4",
      }}
    >
      <Box sx={{ position: "relative" }}>
        <FontAwesomeIcon icon={faFileExcel} style={{ fontSize: 24 }} />
      </Box>
      <Stack
        spacing={2}
        alignItems="center"
        justifyContent="center"
        sx={{ userSelect: "none" }}
      >
        <Typography
          variant="large"
          sx={{
            fontWeight: 600,
            textAlign: "center",
          }}
        >
          {noItemsText}
        </Typography>
        {onClearFilters && (
          <Box sx={{ py: 8 }}>
            <Button
              variant="outlined"
              size="small"
              sx={{ color: "secondary.2", textTransform: "none" }}
              onClick={() => {
                onClearFilters();
              }}
            >
              Clear filters
            </Button>
          </Box>
        )}
      </Stack>
    </Stack>
  );
};
